import { render, staticRenderFns } from "./CategoriesMultiselect.vue?vue&type=template&id=03a57526&scoped=true"
import script from "./CategoriesMultiselect.vue?vue&type=script&lang=js"
export * from "./CategoriesMultiselect.vue?vue&type=script&lang=js"
import style0 from "./CategoriesMultiselect.vue?vue&type=style&index=0&id=03a57526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a57526",
  null
  
)

export default component.exports